//
// Module for the Participant Communication's Portal Messages view
//
rs.module("content/participant/account/communications/portalmessages",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "controls/data/grid",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, gridModule, visibility) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, backendUrls, columnIds, ownerKey, sendingDisabled, showModalOnLoad, cssClasses, messageThreadsGridLrsApi, attachmentsGridLrsApi) {

            // Unpack Js Selectors
            var criteria = $.js(jsSelectors.criteria);

            var messageThreadCard = criteria.js(jsSelectors.messageThreadCard);
            var viewModalLink = messageThreadCard.js(jsSelectors.viewModalLink, { multiple: true, required: false });
            var startNewThreadLink = messageThreadCard.js(jsSelectors.startNewThreadLink, { required: false });

            var statusCard = criteria.js(jsSelectors.statusCard);
            var assignedToSelect = statusCard.js(jsSelectors.assignedToSelect);
            var closedFlagCheckbox = statusCard.js(jsSelectors.closedFlagCheckbox);
            var statusCardCancelButton = statusCard.js(jsSelectors.statusCardCancelButton);
            var hiddenContactLogCrmFolderUpdateToken = statusCard.js(jsSelectors.hiddenContactLogCrmFolderUpdateToken);

            var attachmentsGridLoadingSpinner = criteria.js(jsSelectors.attachmentsGridLoadingSpinner, {multiple: true});

            var modalForm = criteria.js(jsSelectors.modalForm);
            var modalPopup = modalForm.js(jsSelectors.modalPopup);
            var hiddenContactLogCrmFolderKey = criteria.js(jsSelectors.hiddenContactLogCrmFolderKey, { multiple: true });
            var modalHeaderText = modalPopup.js(jsSelectors.modalHeaderText);
            var modalLoadingSpinner = modalPopup.js(jsSelectors.modalLoadingSpinner);
            var modalContent = modalPopup.js(jsSelectors.modalContent);
            var messageThreadView = modalPopup.js(jsSelectors.messageThreadView);
            var newModalContent = modalPopup.js(jsSelectors.newModalContent, { required: false });
            var modalHeaderInput = modalPopup.js(jsSelectors.modalHeaderInput, { required: false });
            var newModalMessageInput = modalPopup.js(jsSelectors.newModalMessageInput, { required: false });
            var existingModalMessageContainer = modalPopup.js(jsSelectors.existingModalMessageContainer, { required: false });
            var existingModalMessageInput = modalPopup.js(jsSelectors.existingModalMessageInput, { required: false });
            var modalSendButton = modalPopup.js(jsSelectors.modalSendButton, { required: false });
            var modalPopupCloseButton = modalPopup.js(jsSelectors.modalPopupCloseButton, { multiple: true });

            // Get select-helper(s) for manipulating select drop down lists
            var assignedToSelectHelper = selectHelper.getHelper(assignedToSelect);

            // On page load, determine if we're showing the modal
            if (showModalOnLoad) {
                var contactLogCrmFolderKey = messageThreadsGridLrsApi.selectedValues[0];
                loadModalPopup(contactLogCrmFolderKey);
            }

            // Handle the subject link button click.
            viewModalLink.click(function () {
                var contactLogCrmFolderKey = $(this).data("folderkey");
                messageThreadsGridLrsApi.selectedValues = contactLogCrmFolderKey;
                loadModalPopup(contactLogCrmFolderKey);
            });

            // Handle the status card's cancel button click.
            if (statusCardCancelButton) {
                statusCardCancelButton.click(function () {

                    // Reset the grid selection to the first row
                    messageThreadsGridLrsApi.selectedValues = null;
                    messageThreadsGridLrsApi.selectFirstRow();
                    eventBanner.removeAllMessages();
                });
            }

            // Hide the Modal popup once Close is clicked
            modalPopupCloseButton.click(function () {
                modalPopup.modal('hide');
                return false;
            });

            // On showing the modal, scroll to the bottom
            modalPopup.on('shown.bs.modal', function () {
                modalContent.scrollTop(modalContent.prop('scrollHeight'));
            });

            // Handle the message thread grid change event
            messageThreadsGridLrsApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // Clear event banner
                    eventBanner.removeAllMessages();

                    // Show the metadata spinners
                    attachmentsGridLoadingSpinner.show();

                    // Update the hidden contact log crm folder key
                    hiddenContactLogCrmFolderKey.val(values[0]);

                    // Retrieve and update the Status card with the selected User ID and the Closed Flag
                    getMessageThreadData(values[0]);

                    // Update the Attachments Grid for attachments within the selected message thread
                    updateAttachmentsGrid(values[0]);

                    // Hide the metadata spinners
                    attachmentsGridLoadingSpinner.hide();
                }

                _executeSelectionChanged = true;
            });

            // Load the modal popup for the given message thread.
            function loadModalPopup(selectedMessageThread) {
                eventBanner.removeAllMessages();

                // If we are changing which modal we are opening, clear the message input.
                // This is to prevent the user from losing their message in the event it fails to send or modal is accidentally closed.
                if (!sendingDisabled && selectedMessageThread != hiddenContactLogCrmFolderKey.val()) {
                    existingModalMessageInput.val('');
                }
                hiddenContactLogCrmFolderKey.val(selectedMessageThread);

                // Set modal item visiblity depending on if it is a new message thread.
                var isNewMessageThread = selectedMessageThread == -1;
                visibility.setVisible(newModalContent, isNewMessageThread);
                visibility.setVisible(modalContent, !isNewMessageThread);
                visibility.setVisible(existingModalMessageContainer, !isNewMessageThread);

                if (!isNewMessageThread) {

                    // Set the folder header
                    modalHeaderText.text(messageThreadsGridLrsApi.selectedRows[0][columnIds.subject]);

                    // Loading spinner
                    modalLoadingSpinner.show();

                    // Load the message threads, do this every time in case a message was sent in the interm.
                    $.get(backendUrls.loadExistingThreadMessagesAsync, { contactLogCrmFolderKey: selectedMessageThread },
                        function (html) {
                            messageThreadView.html(html);
                        })
                        .always(function () {
                            modalLoadingSpinner.hide();
                        });
                }
                else {
                    modalHeaderText.text("New Message Thread");
                }

                modalPopup.modal('show');
            }

            // Ajax call to update the attachment's grid
            function updateAttachmentsGrid(contactLogCrmFolderKey) {
                gridModule.update(
                    backendUrls.getMessageThreadAttachmentsAsync,
                    { contactLogCrmFolderKey: contactLogCrmFolderKey },
                    attachmentsGridLrsApi.agGridApi,
                    function done(gridUpdate) {});
            }

            // Ajax call to retrieve the message thread's associated data
            function getMessageThreadData(contactLogCrmFolderKey) {
                $.get(backendUrls.getMessageThreadDataAsync, { contactLogCrmFolderKey: contactLogCrmFolderKey },
                    function (result) {
                        hiddenContactLogCrmFolderUpdateToken.val(result.updateToken);
                        assignedToSelectHelper.setValue(result.assignedUser);
                        closedFlagCheckbox.setChecked(result.closedFlag);
                    });
            }

            // Ajax call to send a message or start a message thread
            function sendMessage(contactLogCrmFolderKey, ownerKey, message, subject) {

                modalLoadingSpinner.show();
                $.post(
                    backendUrls.sendMessageAsync,
                    {
                        contactLogCrmFolderKey: contactLogCrmFolderKey,
                        ownerKey: ownerKey,
                        message: message,
                        subject: subject
                    })
                    .done(function (result) {
                        if (result.success) {
                            // redirect to new url
                            window.location.href = result.indexUrl;
                        }
                    })
                    .fail(function () {
                        modalLoadingSpinner.hide();
                    });
            }

            // Javascript functionality that is only available if sending is not disabled
            if (!sendingDisabled) {

                // Handle the Start New Thread button click
                startNewThreadLink.click(function () {
                    var contactLogCrmFolderKey = -1;
                    modalHeaderInput.val('');
                    newModalMessageInput.val('');
                    messageThreadsGridLrsApi.selectedValues = null;
                    loadModalPopup(contactLogCrmFolderKey);
                });

                // Reset modal validation messages on modal hide
                modalPopup.on('hide.bs.modal', function (e) {
                    modalHeaderInput.clearErrors();
                    existingModalMessageInput.clearErrors();
                    newModalMessageInput.clearErrors();

                    // If no grid items are selected, select first item
                    if (messageThreadsGridLrsApi.selectedValues.length == 0) {
                        messageThreadsGridLrsApi.selectFirstRow();
                    }
                });

                // Send the modal message
                modalSendButton.click(function () {

                    // Validate
                    if (modalForm.valid()) {

                        // Grab the message from the correct location
                        var message = "";
                        var newMessage = hiddenContactLogCrmFolderKey.val() == -1;
                        if (newMessage) {
                            message = newModalMessageInput.val();
                        }
                        else {
                            message = existingModalMessageInput.val();
                        }

                        // Disable user inputs
                        modalSendButton.addClass(cssClasses._disabled);
                        modalPopupCloseButton.addClass(cssClasses._disabled);
                        modalHeaderInput.prop('disabled', true);
                        newModalMessageInput.prop('disabled', true);
                        existingModalMessageInput.prop('disabled', true);

                        // Send message
                        sendMessage(hiddenContactLogCrmFolderKey.val(), ownerKey, message, modalHeaderInput.val());

                        // We shouldn't get here, but if we do, re-enable inputs.
                        modalSendButton.removeClass(cssClasses._disabled);
                        modalPopupCloseButton.removeClass(cssClasses._disabled);
                        modalHeaderInput.prop('disabled', false);
                        newModalMessageInput.prop('disabled', false);
                        existingModalMessageInput.prop('disabled', false);
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);